import { useEffect, useState } from 'react';

interface Args<T> {
  newItems: T[];
  totalPages: number;
  currentPage: number;
  enabled?: boolean;
}

interface Result<T> {
  items: T[];
  hasMore: boolean;
}

export default function useInfinitePagination<T extends { id: string }>({
  newItems,
  totalPages,
  currentPage,
  enabled = true,
}: Args<T>): Result<T> {
  const [items, setItems] = useState<T[]>([]);

  useEffect(() => {
    if (!enabled) return;
    if (!newItems.length) return;
    if (currentPage === 1) {
      setItems(newItems);
      return;
    }
    setItems((prev) => {
      const existingIds = new Set(prev.map((item) => item.id));
      const unique = newItems.filter((item) => !existingIds.has(item.id));
      return unique.length ? [...prev, ...unique] : prev;
    });
  }, [enabled, newItems, currentPage]);

  return {
    items,
    hasMore: currentPage < totalPages,
  };
}
